import { v4 as generateUUID } from 'uuid';
import axios from 'axios';
import { normalize as normalizeUrl } from '@hotjar/insights-common/lib/url';
import type { Site } from '@hotjar/site';
import type { VerificationResult } from './types';
import type { VerificationResponseDto } from './dto';
import { mapVerificationResultDtoToModel } from './mapper';

function getEndpointPath(uuid: string): string {
  return `/api/v1/tcvs/verification/${uuid}`;
}

const constructVerificationUrl = (verificationURL: string, siteId: SiteId, uuid?: string) => {
  const normalizedUrl = normalizeUrl(verificationURL);
  const url = new URL(normalizedUrl);
  url.searchParams.append('hjVerifyInstall', siteId.toString());
  if (uuid) {
    url.searchParams.append('hjVerifyUUID', uuid);
  }
  return url.toString();
};

const getVerificationPopup = (url: string): Window | null => {
  const width = 500;
  const height = 300;
  const top = window.innerHeight - height - 30; // 30px from the viewport bottom
  const left = 50;

  return window.open(
    url,
    'verifyInstall',
    `toolbar=no, location=no, directories=no, status=no, menubar=no, copyhistory=no, width=${width}, height=${height}, top=${top}, left=${left}`,
  );
};

export const startVerification = async (
  url: string,
  autogenerateRecording = false,
): Promise<string> => {
  const uuid = generateUUID();
  await axios.put(getEndpointPath(uuid), {
    url: normalizeUrl(url),
    autogenerate_recording: autogenerateRecording,
  });
  return uuid;
};

export const getVerificationStatus = async (uuid: string): Promise<VerificationResult> => {
  const response: VerificationResponseDto = await axios.get(getEndpointPath(uuid));
  return mapVerificationResultDtoToModel(response.data);
};

export const openVerificationPopup = (url: string, site: Site, uuid?: string): Window | null => {
  const verificationURL = constructVerificationUrl(url, site.id, uuid);
  return getVerificationPopup(verificationURL);
};
